import { IComponentOptions } from "angular";
import { MachineDetailTabsController } from "./machineDetailTabsController";

export const vsName = "machineDetailsTabsComponent";

export const machineDetailsTabsComponentOptions: IComponentOptions = {
  controller: MachineDetailTabsController,
  template: require("!html-loader!./index.html").default,
  controllerAs: "componentController",
  bindings: {
    machine: "<",
  },
};
